import { requestIdleCallback } from "@lib/requestIdleCallback";

/**
 * wrapper around the FullStory custom event. Prefer to use the hook `useFullstoryLogger` when possible.
 *
 * @param {string} name event that you are logging
 * @param {object?} properties event properties to include
 *
 * @note All analytics calls should be done on idleCallback so as to not block initial render and
 * count against the AJAX / fetch limits of the browser
 */
export const logFullstoryEvent = (eventName: string, properties = {}) => {
  requestIdleCallback(() => {
    if (typeof window.FS === "function") {
      window.FS("trackEvent", {
        name: eventName,
        properties,
      });
    }
  });
};
